import axios from "axios";
import store from "../store";
import Qs from "qs";
import { Loading, MessageBox } from "element-ui";
// import {
//   store
// } from '../store'

var loading;
var hide_loading = true;

// 获取cookie
function getCookie(key) {
  if (document.cookie.length > 0) {
    var start = document.cookie.indexOf(key + "=");
    if (start !== -1) {
      start = start + key.length + 1;
      var end = document.cookie.indexOf(";", start);
      if (end === -1) end = document.cookie.length;
      return unescape(document.cookie.substring(start, end));
    }
  }
  return "";
}
function setCookie(cName, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() - expiredays);
  document.cookie =
    cName +
    "=" +
    decodeURIComponent(value) +
    (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
}
/**
 * 是否隐藏Loading
 *
 * @returns
 */
function isHideLoading() {
  var b = hide_loading;
  hide_loading = false;
  return b;
}
console.log(process.env);
let baseURL =
  process.env.NODE_ENV === "development" ? "/api" : process.env.VUE_APP_BASEURL; // api的base_url
/**
 * 创建axios实例
 */
const request = axios.create({
  baseURL: baseURL,
  timeout: 600000, // 请求超时时间
  withCredentials: true,
  // <---- 这里使用 qs 转换参数 解决php无法接收post传参
  // transformRequest: [function (data) { // 转换数据
  //   data = Qs.stringify(data); // 通过Qs.stringify转换为表单查询参数
  //   return data;
  // }],
  // headers:{
  //   'Content-Type':'application/x-www-form-urlencoded'
  // }
});

// 添加请求拦截器
request.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么
    let localData = sessionStorage.getItem("vuex")
      ? JSON.parse(sessionStorage.getItem("vuex"))
      : "";

    if (localData && localData.token) {
      config.headers["Authorization"] = localData.token;
    }

    // if (!isHideLoading()) {
    //   loading = Loading.service();
    // }

    let url = config.url;
    // get参数编码
    if (
      config.method === "get" ||
      (config.method === "delete" && config.params)
    ) {
      url += "?";
      const keys = Object.keys(config.params);
      for (const key of keys) {
        if (config.params[key] != null) {
          url += `${key}=${encodeURIComponent(config.params[key])}&`;
        }
      }
      url = url.substring(0, url.length - 1);
      config.params = {};
    }
    config.url = url;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    // loading && loading.close();
    return Promise.reject(error);
  }
);

// 添加响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    loading && loading.close();
    if (getCookie("user_id") && store.state.user_id) {
      // console.log(getCookie('user_id'))
      // console.log(store.state.user_id)
      // console.log(getCookie('user_id') == store.state.user_id)
      if (getCookie("user_id") != store.state.user_id) {
        store.dispatch("setToken", getCookie("user_token"));
        store.dispatch("setUser_id", getCookie("user_id"));
        store.dispatch("setUsername", getCookie("real_name"));
        sessionStorage.setItem("is_admin", getCookie("is_admin"));
        sessionStorage.setItem("is_update_data", getCookie("is_update_data"));
        sessionStorage.setItem("company", getCookie("company"));
        sessionStorage.setItem("mobile", getCookie("mobile"));
        sessionStorage.setItem("real_name", getCookie("real_name"));
        sessionStorage.setItem("address", getCookie("address"));
      }
    }
    const res = response.data;

    // code===200 认为是正常返回
    if (res && res.code === 200) {
      return res;
    }

    // token 验证失败
    if (res.code === -2) {
      MessageBox.confirm(
        "会话超时，您可以取消继续留在该页面，或者重新登录",
        "重新登录",
        {
          confirmButtonText: "重新登录",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        sessionStorage.clear();
        store.state.token = "";
        setCookie("user_token", getCookie("user_token"), 1);
        // let currentHash = window.location.hash
        // window.location.hash = `#/login?redirect_hash=${currentHash}`
        // location.reload();
        window.open("https://kac.51kerry.cn/index", "_self");
      });
    }
    return Promise.reject(res);
  },
  (error) => {
    console.log(error);
    // 对响应错误做点什么
    loading && loading.close();
    if (error.response && error.response.data) {
      // 返回了错误信息
      try {
        var data = error.response.data;
        return Promise.reject(data);
      } catch (error) {
        return Promise.reject({
          code: -1,
          message: "网络异常: " + error.response.data,
        });
      }
    } else {
      return Promise.reject({
        code: -1,
        message: error,
      });
    }
  }
);

export default request;
